import * as React from 'react'
import { withRouter } from 'react-router-dom'
import { observer } from 'mobx-react'
import { Modal, Button } from 'react-bootstrap'
import LocalizationStore from '../../../Stores/LocalizationStore'
import HttpActionsService from '../../../Services/HttpActionsService'
import * as FontAwesome from 'react-icons/lib/fa'

@observer
class ProxyCacheClear extends React.Component {

    constructor(props: any) {
        super(props)
        this.state = {
            show: false
        }
    }

    showModal() {
        this.setState({ show: true })
    }

    handleClose(e: any, context: ProxyCacheClear) {
        context.setState({ show: false })
    }

    handleOk(e: any, context: ProxyCacheClear) {
        HttpActionsService.getInstance()
            .clearProxyCache()

        context.setState({ show: false })
    }

    render() {
        const self = this
        const ls = LocalizationStore.getInstance()!

        return (
            <div>
                <Modal
                    show={self.state['show']}
                    onHide={() => { return self.handleClose({}, self) }}
                    animation={false}
                    keyboard={false}
                    backdrop={true}
                >
                    <p className="warningText">{ls.t!('DO YOU REALLY WANT TO CLEAR PROXY CACHE?')}</p>
                    <Button
                        bsStyle="link"
                        onClick={(e) => { return self.handleClose(e, self) }}
                    >
                        {ls.t!('Cancel')}
                    </Button>
                    <Button
                        onClick={(e) => { return self.handleOk(e, self) }}
                        bsStyle="danger"
                    >
                        {ls.t!('Clear')}
                    </Button>

                </Modal>
                <Button
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title={ls.t!('Clear Proxy Cache')}
                    className="create-btn"
                    onClick={() => self.showModal()}
                    data-html="true"
                >
                    {ls.t!('Clear Proxy Cache')}
                </Button>
                <Button
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title={ls.t!('Clear Proxy Cache')}
                    className="create-btn closed"
                    onClick={() => self.showModal()}
                    data-html="true"
                >
                    <FontAwesome.FaRefresh
                        color="white"
                    />
                </Button>
            </div>
        )
    }
}

export default withRouter(ProxyCacheClear)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/ProxyCacheClear/index.tsx